/**
 * Conteúdo estático do módulo PAEBM (GUPM-201) — fiel ao `renderMPAEBM` do V8.
 * SEM PII: o V8 hardcodava o telefone do RT (Giorgi) nos passos; aqui usamos o
 * PAPEL. O telefone real vem do `contacts` (DB) via `useContatosEmergencia`.
 */

export interface DocPaebm {
  dam: 'A' | 'B' | 'C';
  cod: string;
  rev: string;
  disponivel: boolean;
}

/** Documentos do PAEBM por estrutura (Seção I). Só a Barragem B está anexada. */
export const DOCS_PAEBM: readonly DocPaebm[] = [
  { dam: 'A', cod: '[A vincular]', rev: 'Solicitar à Foscentro', disponivel: false },
  { dam: 'B', cod: 'WA02821254-1-HL-RTE-0001', rev: 'Rev. 2 / Abr 2026', disponivel: true },
  { dam: 'C', cod: '[A vincular]', rev: 'Solicitar à Foscentro', disponivel: false },
] as const;

export interface PassoEmergencia {
  icone: string;
  titulo: string;
  desc: string;
}

/** Sequência visual de emergência (PAEBM de bolso). Sem telefone (usa PAPEL). */
export const SEQUENCIA_EMERGENCIA: readonly PassoEmergencia[] = [
  { icone: '📷', titulo: 'Detecte', desc: 'Ruptura visível, tiltímetro ou nível de emergência' },
  { icone: '📢', titulo: 'Acione sirenes', desc: 'ZAS — UPM-01 a 06 (TECAL)' },
  { icone: '📞', titulo: 'Ligue ao RT', desc: 'RT Foscentro / Coordenador PAEBM (contatos abaixo)' },
  { icone: '🧑‍✈️', titulo: 'Coord. PAEBM', desc: 'O RT deflagra o plano' },
  { icone: '🛡️', titulo: 'Evacue a ZAS', desc: 'Apoie a Defesa Civil' },
] as const;

/** Quando acionar a emergência (cenários). */
export const QUANDO_ACIONAR: readonly string[] = [
  'Ruptura em curso visível nas câmeras (galgamento, escorregamento, trinca abrindo, jato de água).',
  'Tiltímetro disparou o acionamento automático das sirenes.',
  'Câmeras E tiltímetros perderam sinal ao mesmo tempo.',
  'RT enquadrou a estrutura em Nível de Emergência (ANM).',
] as const;

/** O que fazer AGORA (passo a passo do vigilante). Sem telefone (usa PAPEL). */
export const O_QUE_FAZER: readonly string[] = [
  'Acione as sirenes (ou confirme o disparo automático).',
  'Ligue para o RT Foscentro (Coordenador PAEBM) — ver Contatos de emergência abaixo.',
  'Comunique o Coordenador do PAEBM (via RT) para deflagrar o plano.',
  'Registre horário e o que viu. Não abandone o posto.',
  'Siga as orientações do RT e apoie a Defesa Civil na evacuação da ZAS.',
] as const;

/**
 * Mensagem do stub de download (documentos ainda não anexados ao app — o dono
 * anexa depois). Fiel ao `paebmDownloadPlaceholder` do V8.
 */
export function mensagemDownloadStub(dam: DocPaebm['dam']): string {
  return dam === 'B'
    ? 'Documento do PAEBM Barragem B ainda não anexado a este protótipo.'
    : `PAEBM Barragem ${dam} — documento a solicitar à Foscentro. Contate o RT Foscentro.`;
}
